/***
 *
 *   SIGN UP STEP 2 — plan
 *   Phase 9 — signup chrome + step indicator.
 *
 **********/

import React, { useContext } from 'react';
import { Animate, PaymentForm, usePlans, ProgressSteps, useNavigate } from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { AuthContext } from 'app/auth';
import { useTranslate } from 'app/translations';
import { useApiContext } from 'app/api';

const STEPS = (t) => [
    { key: 'account', name: t('user.create.label'), icon: 'user', completed: true },
    { key: 'plan', name: t('plan.label'), icon: 'credit-card', completed: false },
];

export function SignupPlan(props) {
    const { _t } = useTranslate();
    const context = useContext(AuthContext);
    const navigate = useNavigate();
    const plans = usePlans();
    const { postEvent } = useApiContext();

    const plan = window.location.hash.substring(1);

    if (!plans.data) return false;

    return (
        <Animate type="pop">
            <AuthPage title={_t('plan.select')} description={_t('signup.planDescription')}>
                <ProgressSteps items={STEPS(_t)} current={1} />

                <PaymentForm
                    data={{
                        plan: {
                            label: _t('plan.label'),
                            type: 'select',
                            options: plans.data.list,
                            default: plan,
                            required: true,
                        },
                        token: {
                            label: _t('creditCard.label'),
                            type: 'creditcard',
                            required: true,
                        },
                    }}
                    url="/api/account/plan"
                    method="POST"
                    buttonText={_t('plan.save')}
                    callback={(res) => {
                        postEvent('selected_plan', { plan: res.data.plan });
                        context.update({
                            plan: res.data.plan,
                            subscription: res.data.subscription,
                        });
                        navigate(res.data.onboarded ? '/app/tickets' : '/app/onboarding');
                    }}
                />
            </AuthPage>
        </Animate>
    );
}
